import React from 'react';
import './parallaxText.css';

export const ParallaxText = () => {
    return (
        <div className="content">
            <p className='pC'>welcome to my portfolio</p>
        </div>
    )
}